import {
  extractFlightFilterData,
  IExtractFlightFilter,
  IExtractFlightReturnType,
} from "@/feature/flight/search/lib/filtering/extract-filter-data";
import { IFlight } from "@/feature/flight/search/types/flight";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IFlightSelectOption {
  type?: "CHEAPEST" | "SHORTEST" | "EARLIEST";
  price_range?: number[];
  airline?: string[];
  stoppage?: {
    [legIndex: number]: number[];
  };
  refundable?: boolean;
  aircraft?: string[];
  max_layover?: { index: number; value: number } | undefined;
  min_layover?: { index: number; value: number } | undefined;
  layover_city?: string[] | undefined;
  timeFrame?:
  | {
    type: "departure" | "arrival";
    code: string;
    time: string;
    arr_index: number;
  }[]
  | undefined;
  flight_number?: string[];
}

interface UnifiedFlightFilterState {
  searchId: string;
  defaultOption: IExtractFlightReturnType;
  selectOption: IFlightSelectOption;
  cachedFlights: IFlight[];
}

const initialState: UnifiedFlightFilterState = {
  searchId: "",
  defaultOption: {
    price_range: undefined,
    aircraft: [],
    airlines_lowest_price: [],
    layover: [],
    layover_city: [],
    layover_range: [],
    time_frame: undefined,
    flight_numbers: [],
  },
  selectOption: { price_range: [] },
  cachedFlights: [],
};

const extractFlightFilter = createSlice({
  name: "flightFilter",
  initialState,
  reducers: {
    setFlightResult: (state, action: PayloadAction<IExtractFlightFilter>) => {
      const result = extractFlightFilterData(action.payload);
      state.defaultOption = result;
      state.searchId = action.payload.searchInfo?.search_id ?? "";
      // Cache the raw flight list for remount
      state.cachedFlights = action.payload.flightResult ?? [];
    },
    setFilters: (
      state,
      action: PayloadAction<Partial<IFlightSelectOption>>,
    ) => {
      state.selectOption = {
        ...state.selectOption,
        ...action.payload,
      };
    },
    resetFlightFilter: (state) => {
      state.selectOption = initialState.selectOption;
      state.defaultOption = initialState.defaultOption;
      state.searchId = initialState.searchId;
      state.cachedFlights = initialState.cachedFlights;
    },
    resetSelectOption: (state) => {
      state.selectOption = {
        ...initialState.selectOption,
        type: "CHEAPEST",
      };
    },
  },
});

export const {
  setFlightResult,
  setFilters,
  resetFlightFilter,
  resetSelectOption,
} = extractFlightFilter.actions;

export default extractFlightFilter;
